"use strict";
/* globals module */
/**
 * @module commerceProductInstanceFilesRoute
 * @description Baasic Product Instance Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Product Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
;
var contracts_1 = require("../../../../core/contracts");
var __1 = require("../../");
var CommerceProductInstanceFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductInstanceFilesRoute, _super);
    function CommerceProductInstanceFilesRoute(productInstanceFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.productInstanceFilesBatchRoute = productInstanceFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'products/{productId}/files/{?searchQuery,ids,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'products/{productId}/files/{id}/{?embed,fields}';
        _this.linkRoute = 'products/{productId}/files/link';
        _this.unlinkRoute = 'products/{productId}/files/unlink/{id}';
        _this.unlinkByProductRoute = 'products/{productId}/files/unlink';
        _this.updateRoute = 'products/{productId}/files/{id}';
        return _this;
    }
    Object.defineProperty(CommerceProductInstanceFilesRoute.prototype, "batch", {
        get: function () {
            return this.productInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param productId Product slug or id which uniquely identifies product whose product files need to be retrieved.
     * @param options Query resource options object.
     * @example productInstanceFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceProductInstanceFilesRoute.prototype.find = function (productId, options) {
        var params = this.modelMapper.findParams(options);
        params.productId = productId;
        return _super.prototype.baseGet.call(this, this.findRoute, params);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param productId Product id which uniquely identifies product whose product files need to be retrieved.
     * @param id Product file id which uniquely identifies product file that needs to be retrieved.
     * @param options options object that contains embed data.
     * @example productInstanceFilesRoute.get({id: '<file-id>'});
     **/
    CommerceProductInstanceFilesRoute.prototype.get = function (productId, id, options) {
        var params = this.utility.extend({}, options);
        params.productId = productId;
        params.id = id;
        return _super.prototype.baseGet.call(this, this.getRoute, params);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @param productId Product id which uniquely identifies product whose product files need to be deleted.
     * @param data
     * @param options
     * @example productInstanceFilesRoute.link();
     **/
    CommerceProductInstanceFilesRoute.prototype.link = function (productId, data) {
        var params = this.utility.extend({}, data);
        params.productId = productId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param productId Product id which uniquely identifies gallery whose gallery files need to be deleted.
     * @param data
     * @param options
     * @example productFilesRoute.unlink(data);
     **/
    CommerceProductInstanceFilesRoute.prototype.unlink = function (productId, data, options) {
        if (!options) {
            options = {};
        }
        var params = this.modelMapper.removeParams(data);
        params.productId = productId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params, options, 'unlink');
    };
    /**
     * Parses unlink by Product route; this URI template does not expose any additional options.
     * @method
     * @param productId Product id which uniquely identifies product whose product files need to be deleted.
     * @param data
     * @param options
     * @example productFilesRoute.unlinkByProduct(data);
     **/
    CommerceProductInstanceFilesRoute.prototype.unlinkByProduct = function (productId, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkByProductRoute, productId, options, 'unlink-by-product');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example productInstanceFilesRoute.update(data);
     **/
    CommerceProductInstanceFilesRoute.prototype.update = function (productId, data) {
        var params = this.modelMapper.updateParams(data);
        params.productId = productId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    var _a, _b;
    CommerceProductInstanceFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceProductInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceProductInstanceFilesBatchRoute !== "undefined" && __1.CommerceProductInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceProductInstanceFilesRoute);
    return CommerceProductInstanceFilesRoute;
}(common_1.BaseRoute));
exports.CommerceProductInstanceFilesRoute = CommerceProductInstanceFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 
